export default "__VITE_ASSET__BtnDjpyH__"